import { useQuery } from '@apollo/client';
import { GET_DASHBOARD_NEW_TALENTS } from '@gql/alerts';

export const useGetDashboardNewTalents = (date?: Date, limit = 10) => {
    const { data, loading, error, refetch } = useQuery(GET_DASHBOARD_NEW_TALENTS, {
        variables: { limit, ...(date && { date }) },
        notifyOnNetworkStatusChange: true,
    });

    return {
        talents: data?.getDashboardNewTalents ?? [],
        loading,
        error,
        refetch,
    };
};
